import { Component, OnDestroy, OnInit } from '@angular/core'
import { ToastService } from '../services/toast.service'
import { Toast, ToastType } from '../domain/Toast'

@Component({
    selector: 'app-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.sass'],
})
export class ToastsComponent implements OnInit, OnDestroy {
    keepall = true

    constructor(public toastService: ToastService) {}

    ngOnInit() {}

    onDismissToast(toast: Toast) {
        this.toastService.remove(toast)
    }

    ngOnDestroy(): void {
        this.toastService.clear()
    }

    protected readonly ToastType = ToastType
}
